import { render, staticRenderFns } from "./QuickInspectListComponent.vue?vue&type=template&id=e63642da&scoped=true&"
import script from "./QuickInspectListComponent.vue?vue&type=script&lang=ts&"
export * from "./QuickInspectListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuickInspectListComponent.vue?vue&type=style&index=0&id=e63642da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63642da",
  null
  
)

export default component.exports